import axios from 'axios'
export const state = {
  departmentList: [],
}

export const getters = {}

export const mutations = {
  CACHE_DEPARTMENT_LIST(state, newList) {
    state.departmentList = newList
  },
}

export const actions = {
  fetchDepartmentList({ commit, state, rootState }) {
    return axios
      .get(`${process.env.VUE_APP_API_BASE_URL}/departments`)
      .then((response) => {
        const data = response.data
        const list = {}
        commit('CACHE_DEPARTMENT_LIST', list)
        return data
      })
  },

  addDepartment({ commit, state, rootState }, { Data }) {
    return axios
      .post(`${process.env.VUE_APP_API_BASE_URL}/departments`, Data)
      .then((response) => {
        const resp = response.data
        return resp
      })
  },

  updateDepartment({ commit, state, rootState }, { Data }) {
    return axios
      .patch(`${process.env.VUE_APP_API_BASE_URL}/departments/${Data.id}`, Data)
      .then((response) => {
        const resp = response.data
        return resp
      })
  },

  deleteDepartment({ commit, state, rootState }, { Data }) {
    return axios
      .delete(`${process.env.VUE_APP_API_BASE_URL}/departments/${Data.id}`)
      .then((response) => {
        const data = response.data
        return data
      })
  },
}
